export interface Category {
  id: string;
  name: string;
  short: string;
  desc: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  {
    id: 'yule',
    name: '娱乐圈瓜',
    short: '娱圈',
    desc: '合约、番位、绯闻、解约与公关声明，一条时间线理清谁先动的手。',
    icon: 'ri-music-2-line',
    count: 42,
  },
  {
    id: 'wanghong',
    name: '网红翻车',
    short: '网红',
    desc: '带货、打假、塌房、互撕，从爆红到翻车的全过程复盘。',
    icon: 'ri-live-line',
    count: 37,
  },
  {
    id: 'shangye',
    name: '商业互撕',
    short: '商战',
    desc: '对赌、抄袭、加盟纠纷、股权暗战，梳理商战背后的每一次交锋。',
    icon: 'ri-line-chart-line',
    count: 28,
  },
  {
    id: 'keji',
    name: '科技圈瓜',
    short: '科技',
    desc: '发布会翻车、产品争议、大佬喊话，科技圈的名场面合集。',
    icon: 'ri-cpu-line',
    count: 19,
  },
  {
    id: 'zongyi',
    name: '综艺影视',
    short: '影视',
    desc: '剧本疑云、剪辑争议、CP 真假、片场风波，追完再下判断。',
    icon: 'ri-movie-2-line',
    count: 24,
  },
];